import React, { useState } from 'react';
import { Plus, Minus } from 'lucide-react';
export function FAQSection() {
  const faqs = [{
    q: 'Is this a physical product?',
    a: 'No. Pilates Ready is a 100% digital product delivered instantly after purchase.'
  }, {
    q: 'Can beginners use it?',
    a: 'Yes. The system was designed to help both new and experienced Pilates instructors.'
  }, {
    q: 'Does it work for Reformer and Mat classes?',
    a: 'Yes. The system includes programming applicable to both modalities.'
  }, {
    q: 'How do I receive access?',
    a: "Immediately after purchase you'll receive access by email."
  }];
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-pilates-cream py-20 px-4 sm:px-6 lg:px-8" data-id="element-71">
      <div className="max-w-3xl mx-auto" data-id="element-72">
        <div className="text-center mb-12" data-id="element-73">
          <div className="bg-pilates-sage/15 text-pilates-sage-dark font-semibold text-xs px-4 py-1.5 rounded-full mb-6 inline-block uppercase tracking-[0.2em]" data-id="element-74">
            FREQUENTLY ASKED QUESTIONS
          </div>
          <h2 className="font-display text-3xl sm:text-4xl md:text-5xl font-medium text-pilates-dark leading-tight tracking-tight" data-id="element-75">
            Answering{' '}
            <span className="italic text-pilates-rose" data-id="element-76">your questions</span>
          </h2>
        </div>

        <div className="space-y-3" data-id="element-77">
          {faqs.map((faq, idx) => <div key={idx} className="bg-white rounded-2xl border border-pilates-sage/20 overflow-hidden shadow-sm" data-id="element-78">
              <button onClick={() => setOpen(open === idx ? null : idx)} className="w-full flex items-center justify-between p-5 text-left hover:bg-pilates-cream/40 transition-colors" data-id="element-79">
                <span className="font-display font-semibold text-pilates-dark text-base sm:text-lg pr-4" data-id="element-80">
                  {faq.q}
                </span>
                <div className="flex-shrink-0 bg-pilates-sage-dark text-white w-8 h-8 rounded-full flex items-center justify-center" data-id="element-81">
                  {open === idx ? <Minus className="w-4 h-4" data-id="element-82" /> : <Plus className="w-4 h-4" data-id="element-83" />}
                </div>
              </button>
              {open === idx && <div className="px-5 pb-5 text-pilates-slate leading-relaxed" data-id="element-84">
                  {faq.a}
                </div>}
            </div>)}
        </div>
      </div>
    </section>;
}